<template>
<div v-if="profile" class="small-profile-card glass-element">
    <notifications position="bottom right" group="invitation" />

    <div>{{ profile.username }}</div>
    <v-btn v-if="!loading" @click="invite">
        <v-icon v-if="!invited">mdi-plus</v-icon>
    </v-btn>
    <div v-if="loading">
        <TinyLoaderLight />
    </div>
</div>
</template>

<script>
import TinyLoaderLight from "@/components/atoms/TinyLoaderLight";

export default {
    components: {
        TinyLoaderLight
    },
    props: ["profile", "event_id", "event_slug"],
    data() {
        return {
            loading: false,
            invited: false,
        };
    },
    methods: {
        async invite() {
            this.loading = true;
            await this.$store
                .dispatch("createInvitation", {
                    invitee: this.profile.id,
                    inv_event: this.event_id,
                    status: "PE",
                    order: 0,
                })
                .then(() => (this.loading = false))
                .then(() => this.$store.dispatch("eventDetails", this.event_slug))
                .then(() => (this.invited = true))
                .then(() => this.$notify({
                    group: 'invitation',
                    title: "invitation",
                    type: 'success',
                    text: this.profile.username + " invited!"
                }));
        },
    },
};
</script>

<style scoped>
.small-profile-card {
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 8px;
}
</style>
